import React,{useState,useEffect,useRef} from "react";
import css from "./BubblingView.module.css";


export default function BubblingView(props){
    const [coordinates,setCoordinates]=useState();
    const [_,render]=useState(false);
    const state=useRef({
        ref:useRef(),
        step:100*statics.step*rem,
    }).current,{step}=state;
    useEffect(()=>{
        if(!coordinates){
            const element=state.ref.current,{width,height}=element.getBoundingClientRect();
            state.width=width;
            state.height=height;
            setCoordinates(new Array(statics.bubblecount).fill().map(()=>[
                100*Math.random()*width/window.innerWidth,
                100*Math.random()*height/window.innerHeight,
            ]));
        }
        const timeout=setTimeout(()=>{render(!_)},coordinates?statics.duration:0);
        return ()=>{
            coordinates&&clearTimeout(timeout);
        };
    });
    return (
        <div ref={state.ref} className={`${css.bubblingview} ${props.className||""}`}>
            {coordinates?.map((coords,i)=>{
                const x=coords[0]=coords[0]+(Math.random()-0.5)*step/window.innerWidth;
                const y=coords[1]=coords[1]+(Math.random()-0.5)*step/window.innerHeight;
                return <span 
                    key={"bubble"+i}
                    className={css.bubble}
                    style={{
                        transform:`translate(${x}rem,${y}rem) scale(${Math.random()})`,
                        transitionDuration:`${statics.duration}ms`,
                    }}
                />
            })}
        </div>
    )
}

const statics={
    bubblecount:window.innerWidth<567?200:300,
    duration:2500,
    step:8,
}
